import { Input, Col, Row, Space, Checkbox, Select } from "antd";
import { useState, useCallback, useEffect } from "react";
import { useLanguage } from "../../../../../../context/LanguageContext";

interface PositionsControlsProps {
  onApply: (
    position: string,
    pallet: string,
    status: string[],

  ) => void;
}

const PositionsControls = (props: PositionsControlsProps) => {
  const { language } = useLanguage();
  const [position, setPosition] = useState<string>("");
  const [pallet, setPallet] = useState<string>("");
  const [status, setStatus] = useState<string[]>([]);


  const onApply = useCallback(() => {
    props.onApply(position, pallet,status);
  }, [props, position, pallet,status]);

  useEffect(() => {
    onApply();
  }, [onApply]);

  return (
    <Row gutter={[10, 10]} align="middle" >
      <Col xs={24} sm={8} md={8} lg={6}>
        <Space direction="vertical" style={{ width: '100%' }}>
          {language==="es"?"Posición: ":"Position: "}
          <Input
            allowClear
            placeholder={language==="es"?"Posición":"Position"}
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          />
        </Space>
      </Col>
      <Col xs={24} sm={8} md={8} lg={6}>
        <Space direction="vertical" style={{ width: '100%' }}>
          Pallet: 
          <Input
            allowClear
            placeholder="Pallet"
            value={pallet}
            onChange={(e) => setPallet(e.target.value)}
          />
        </Space>
      </Col>
      <Col xs={24} sm={8} md={8} lg={8}>
        <Space direction="vertical" style={{ width: "100%" }}>
          {language === "es" ? "Mostrar:" : "Show:"}
          <Select
            style={{ width: "100%" }}
            value={status}
            mode="multiple"
            placeholder={language === "es" ? "Todos" : "All"}
            onChange={setStatus}
            options={[
              { value: "untracked", label: language === "es" ? "Sin seguimiento" : "Untracked" },
              { value: "accepted", label: language === "es" ? "Aceptada" : "Accepted" },
              { value: "rejected", label: language === "es" ? "Rechazada" : "Rejected" },
            ]}
          />
        </Space>
      </Col>
    </Row>
  );
};

export default PositionsControls;
